document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (document.body.classList.contains('template-index')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  // Use slightly delayed initialization to ensure DOM is fully parsed
  setTimeout(() => {
    // Staggered fade up for product cards and grids
    const grids = document.querySelectorAll('[data-moz-reveal-grid]');
    
    grids.forEach(grid => {
      const cards = grid.querySelectorAll('[data-moz-reveal-item]');
      if (cards.length > 0) {
        gsap.fromTo(cards, 
          { y: 30, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1.2,
            stagger: 0.08,
            ease: "power4.out",
            scrollTrigger: {
              trigger: grid,
              start: "top 85%",
              toggleActions: "play none none reverse"
            }
          }
        );
      }
    });

    // Reveal effect for section headings (excluding those using themes built-in animated-titles)
    const headings = document.querySelectorAll('[data-moz-reveal-heading]');
    headings.forEach(heading => {
      if (heading.textContent.trim() !== "") {
        gsap.fromTo(heading,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
              trigger: heading,
              start: "top 90%",
              toggleActions: "play none none reverse"
            }
          }
        );
      }
    });

    // Parallax effect for primary images/banners inside media containers
    const banners = document.querySelectorAll('[data-moz-parallax-media]');
    banners.forEach(banner => {
      const img = banner.querySelector('img');
      if (img) {
        gsap.fromTo(img, 
          { yPercent: -15, scale: 1.1 },
          {
            yPercent: 15,
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: banner,
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          }
        );
      }
    });

    // Refresh ScrollTrigger to recalculate positions correctly after all setups
    ScrollTrigger.refresh();
  }, 150);
});
